import { render, staticRenderFns } from "./LegalSignIndex.vue?vue&type=template&id=ffa5eb78&scoped=true&"
import script from "./LegalSignIndex.vue?vue&type=script&lang=js&"
export * from "./LegalSignIndex.vue?vue&type=script&lang=js&"
import style0 from "./LegalSignIndex.vue?vue&type=style&index=0&id=ffa5eb78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa5eb78",
  null
  
)

export default component.exports